export const GuestLinkKeyFactory = {
    all: (params) => [
        'workspaces',
        params.workspaceId,
        'filespaces',
        params.filespaceId,
        'guest-links',
    ],
    list: (params) => [
        ...GuestLinkKeyFactory.all(params),
        'list',
    ],
    /**
     * Shared mutation key: guest-link mutations gate their settle-time
     * refetches on `isMutating` with this key, so only the last pending
     * mutation refetches and cannot wipe another's optimistic state.
     */
    mutations: (params) => [
        ...GuestLinkKeyFactory.all(params),
        'mutations',
    ],
    exact: (params) => [...GuestLinkKeyFactory.all(params), 'exact', params.linkId],
    entryPath: (params) => [...GuestLinkKeyFactory.all(params), 'path', params.fsEntryId],
};
